import { SITE_NAME, SITE_URL } from "@/constants/site";

interface PageSEOProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
}

export default function PageSEO({ title, description, keywords, path }: PageSEOProps) {
  const canonical = `${SITE_URL}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}